/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetBankTransfer200ResponseRequestedBy } from './get-bank-transfer200-response-requested-by';
// May contain unused imports in some cases
// @ts-ignore
import { GetBankTransfer200ResponseSourceBankAccount } from './get-bank-transfer200-response-source-bank-account';

/**
 * 
 * @export
 * @interface GetBankTransfer200Response
 */
export interface GetBankTransfer200Response {
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200Response
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof GetBankTransfer200Response
     */
    'totalCount': number;
    /**
     * 
     * @type {number}
     * @memberof GetBankTransfer200Response
     */
    'totalAmount': number;
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200Response
     */
    'fileFormat': GetBankTransfer200ResponseFileFormatEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetBankTransfer200Response
     */
    'paymentRequestIds': Array<string>;
    /**
     * 
     * @type {GetBankTransfer200ResponseSourceBankAccount}
     * @memberof GetBankTransfer200Response
     */
    'sourceBankAccount': GetBankTransfer200ResponseSourceBankAccount;
    /**
     * 
     * @type {GetBankTransfer200ResponseRequestedBy}
     * @memberof GetBankTransfer200Response
     */
    'requestedBy': GetBankTransfer200ResponseRequestedBy;
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200Response
     */
    'processedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetBankTransfer200Response
     */
    'transferAt': string;
    /**
     * null if the transfer data has not been downloaded.
     * @type {string}
     * @memberof GetBankTransfer200Response
     */
    'downloadedAt': string | null;
}

export const GetBankTransfer200ResponseFileFormatEnum = {
    disableLineBreak: 'ZENGIN_DISABLE_LINE_BREAK',
    enableLineBreak: 'ZENGIN_ENABLE_LINE_BREAK',
    csv: 'ZENGIN_CSV'
} as const;

export type GetBankTransfer200ResponseFileFormatEnum = typeof GetBankTransfer200ResponseFileFormatEnum[keyof typeof GetBankTransfer200ResponseFileFormatEnum];


